export const abbrev = {
    cdo: "chief diversity officer",
    ceo: "chief executive officer",
    cfo: "chief financial officer",
    coo: "chief operating officer",
    evp: "executive vice president",
    ceco: "chief environmental commitment officer",
    cgo: "chief green officer",
    gm: "general manager",
    plm: "product line manager",
    gam: "global account manager",
    mgo: "major gifts officer",
    cio: "chief information officer",
    cto: "chief technology officer",
    avp: "assistant vice president",
    bcm: "banking center manager",
    dmm: "division merchandise manager",
    afm: "accredited farm manager",
    ovfm: "organic vegetable farm manager",
    gfm: "group fitness manager",
    cra: "clinical research associate",
    sdo: "distribution operation supervisor",
    pmr: "postmaster relief",
    owdpm: "offender workforce development program manager",
    cso: [
        "chief security officer",
        "consumer safety officer"
    ],
    lsrp: "licensed site remediation professional",
    cesswi: "certified erosion, sediment, and storm water inspector",
    cde: "certified driver examiner",
    psr: "public service representative",
    tsr: [
        "transportation services representative",
        "telephone sales representative",
        "telephone service representative"
    ],
    mli: "medical legal investigator",
    csm: [
        "convention services manager",
        "casino shift manager"
    ],
    cpa: "certified public accountant",
    cfa: [
        "chartered financial analyst",
        "certified first assistant"
    ],
    cfp: "certified financial planner",
    ctp: "certified income tax preparer",
    isa: "information systems analyst",
    cissp: "certified information systems security professional",
    isso: "information systems security officer",
    cne: "certified novell engineer",
    ccie: "cisco certified internetwork expert",
    ccnp: "cisco certified network professional",
    dba: "database administrator",
    cna: [
        "certified novell administrator",
        "certified nursing assistant",
        "certified nurses aide",
        "certified nurses' aide",
        "certified nurse aide",
        "certified nursing attendant"
    ],
    ccna: "cisco certified network associate",
    rcdd: "registered communications distribution designer",
    seo: "search engine optimizer",
    sqe: "supplier quality engineer",
    bmet: [
        "biomedical equipment technician",
        "biomedical engineering technician"
    ],
    esa: "equipment services associate",
    est: "electronic systems technician",
    leot: "laser/electro-optics technician",
    icp: "infection control practitioner",
    msl: "medical science liaison",
    rehs: "registered environmental health specialist",
    abss: "applied behavior science specialist",
    lpc: "licensed professional counselor",
    clt: "central lab technician",
    nlo: "non-licensed nuclear plant operator",
    neo: "nuclear equipment operator",
    napeo: "nuclear plant equipment operator",
    rpt: [
        "radiation protection technician",
        "registered physical therapist"
    ],
    adac: "certified alcohol and drug counselor",
    cadc: "certified alcohol drug counselor",
    dats: "drug and alcohol treatment specialist",
    sac: "student assistance counselor",
    oes: "offender employment specialist",
    owds: "offender workforce development specialist",
    lmft: "licensed marriage and family therapist",
    mft: "marriage and family therapist",
    bss: "behavior support specialist",
    cc: "correctional counselor",
    eia: "employment instructional associate",
    vrc: "vocational rehabilitation counselor",
    lcsw: "licensed clinical social worker",
    cbe: "certified breastfeeding educator",
    clc: "certified lactation counselor",
    cjpo: "chief juvenile probation officer",
    dpo: "deputy probation officer",
    po: "parole officer",
    chw: "community health worker",
    csr: "certified shorthand reporter",
    gsi: "graduate student instructor",
    gta: "graduate teaching assistant",
    ra: [
        "research assistant",
        "residential aide",
        "restorative aide"
    ],
    ta: [
        "teaching assistant",
        "technical associate"
    ],
    cfi: "certified flight instructor",
    lta: "library technical assistant",
    vm: "visual merchandiser",
    mco: [
        "master control operator",
        "multicraft operator"
    ],
    y: "radio television technical director",
    dj: "disc jockey",
    mc: "master of ceremonies",
    reo: "radio electronics officer",
    ret: "radio electronics technician",
    dc: "chiropractic doctor",
    dds: "doctor of dental surgery",
    dmd: "doctor of dental medicine",
    oms: "oral and maxillofacial surgeon",
    od: "doctor of optometry",
    pic: "pharmacist in charge",
    md: "medical doctor",
    do: "osteopathy doctor",
    pa: "physician assistant",
    pac: "physician assistant certified",
    dpm: "doctor of podiatric medicine",
    dp: "podiatry doctor",
    ot: "occupational therapist",
    coms: "certified orientation and mobility specialist",
    tvi: "teacher of students with visual impairments",
    vrt: "vision rehabilitation therapist",
    dpt: "doctor of physical therapy",
    gp: "general practitioner",
    rtt: [
        "radiation therapy technologist",
        "respiratory therapy technician"
    ],
    ctrs: "certified therapeutic recreation specialist",
    crt: "certified respiratory therapist",
    rrt: "registered respiratory therapist",
    rcp: "respiratory care practitioner",
    rt: [
        "respiratory therapist",
        "radiologic technologist",
        "radiologic technician"
    ],
    slp: "speech-language pathologist",
    epc: "certified exercise physiologist",
    dvm: "doctor of veterinary medicine",
    cnor: "certified nurse operating room",
    don: "director of nursing",
    phn: "public health nurse",
    rn: "registered nurse",
    ccrn: "critical care registered nurse",
    crna: "certified registered nurse anesthetist",
    dnap: "doctor of nurse anesthesia practice",
    cnm: "certified nurse midwife",
    aprn: "advanced practice registered nurse",
    fnp: "family nurse practitioner",
    lnp: "licensed nurse practitioner",
    nnp: "neonatal nurse practitioner",
    np: "nurse practitioner",
    pnp: "pediatric nurse practitioner",
    aud: "audiology doctor",
    lac: "licensed acupuncturist",
    co: [
        "clinical orthoptist",
        "certified orthotist",
        "corrections officer"
    ],
    cls: "clinical laboratory scientist",
    mt: "medical technologist",
    ccs: "clinical cytogeneticist scientist",
    mlt: "medical laboratory technician",
    rdh: "registered dental hygienist",
    cvt: [
        "cardiovascular technologist",
        "certified veterinary technician"
    ],
    ctt: "computed tomography technologist",
    rcis: "registered cardiovascular invasive specialist",
    rdms: "registered diagnostic medical sonographer",
    cnmt: "certified nuclear medicine technologist",
    emt: "emergency medical technician",
    cdm: "certified dietary manager",
    cct: [
        "cook chill technician",
        "certified composites technician"
    ],
    dtr: "diet technician registered",
    lpt: "licensed psychiatric technician",
    mha: "mental health aide",
    mht: "mental health technician",
    pt: "psychiatric technician",
    stm: "support team member",
    crtt: "certified respiratory therapy technician",
    rpft: "registered pulmonary function technologist",
    rca: [
        "respiratory care assistant",
        "resident care assistant",
        "rural carrier associate"
    ],
    cst: [
        "certified surgical technologist",
        "central service technician",
        "customer service technician"
    ],
    lvt: "licensed veterinary technician",
    rvt: "registered veterinary technician",
    cot: "certified ophthalmic technician",
    lpn: "licensed practical nurse",
    lvn: "licensed vocational nurse",
    cpc: [
        "certified professional coder",
        "certified personal chef",
        "certified professional controller"
    ],
    cdis: "clinical documentation improvement specialist",
    rhit: "registered health information technician",
    ldo: "licensed dispensing optician",
    cp: "certified prosthetist",
    cpo: "certified prosthetist and orthotist",
    lpo: "licensed prosthetist and orthotist",
    his: "hearing instrument specialist",
    cmt: [
        "certified medical technician",
        "certified massage therapist"
    ],
    cdos: "certified diagnostic ophthalmic sonographer",
    comt: "certified ophthalmic medical technologist",
    roub: "registered ophthalmic ultrasound biometrist",
    endt: "electroneurodiagnostic technician",
    crnfa: "certified registered nurse first assistant",
    csa: [
        "certified surgical assistant",
        "customer service associate"
    ],
    csfa: "certified surgical first assistant",
    rnfa: "registered nurse first assistant",
    cih: "certified industrial hygienist",
    chst: "construction health and safety technician",
    chha: "certified home health aide",
    cma: "certified medical aide",
    dsp: [
        "direct support professional",
        "direct service professional"
    ],
    hss: "health support specialist",
    hha: "home health aide",
    lna: "licensed nursing assistant",
    stna: "state tested nursing assistant",
    bha: "behavioral health aide",
    ddscta: "developmental diabetes secure care treatment aide",
    mhw: "mental health worker",
    pca: "personal care assistant",
    pna: "professional nursing assistant",
    tpw: "therapeutic program worker",
    cena: "competency evaluated nurse aide",
    pct: "patient care technician",
    cota: "certified occupational therapy assistant",
    ota: "occupational therapy assistant",
    cora: "certified occupational rehabilitation aide",
    cpta: "certified physical therapist assistant",
    lpta: "licensed physical therapist assistant",
    pta: "physical therapy aide",
    lmp: "licensed massage practitioner",
    cda: "certified dental assistant",
    da: "dental assistant",
    edda: "expanded duty dental assistant",
    rda: "registered dental assistant",
    ma: "medical assistant",
    rma: "registered medical assistant",
    cpt: "central processing technician",
    cspdt: "central supply processing department technician",
    crcst: "certified registered central service technician",
    mra: "material reprocessing associate",
    pst: "patient service technician",
    slpa: "speech - language pathology assistant",
    cfer: "certified flexible endoscope reprocessor",
    csi: [
        "crime scene investigator",
        "consumer safety inspector"
    ],
    cbpi: "customs and border protection inspector",
    cbpo: "customs and border protection officer",
    leo: "law enforcement officer",
    peo: "parking enforcement officer",
    tso: "transportation security officer",
    apa: "asset protection associate",
    lpa: "loss prevention associate",
    cec: "certified executive chef",
    dmo: "dish machine operator",
    evs: "environmental services supervisor",
    gra: "guest room attendant",
    gdmi: "guide dog mobility instructor",
    acg: "animal care giver",
    fsa: [
        "family services assistant",
        "funeral services assistant"
    ],
    ae: "account executive",
    fsr: "financial services representative",
    mvfr: "motor vehicle field representative",
    ccr: "customer care representative",
    msc: "medicaid service coordinator",
    prr: "patient relations representative",
    wsr: "workforce services representative",
    gsa: "guest services agent",
    eco: [
        "emergency communications officer",
        "emergency communications operator"
    ],
    etd: "emergency telecommunications dispatcher",
    ssa: "sales and service associate",
    cca: "city carrier assistant",
    pdpmo: "parcel post distribution machine operator",
    asa: "administrative support assistant",
    eo: "equipment operator",
    meo: "maintenance equipment operator",
    tms: "transportation maintenance specialist",
    teo: "track equipment operator",
    cmo: [
        "continuous miner operator",
        "continuous mining operator",
        "chief mechanical officer"
    ],
    mcf: "maintenance and condition assessment foreman",
    mcl: "maintenance and condition assessment lead",
    ttalf: "telecommunications tower antenna and line foreman",
    ttall: "telecommunications tower antenna and line lead",
    ttcf: "telecommunications tower construction foreman",
    amt: "aviation maintenance technician",
    cat: "certified appliance technician",
    cbet: [
        "certified biomedical engineering technician",
        "certified biomedical equipment technician"
    ],
    cml: "certified master locksmith",
    cms: "certified master safecracker",
    rst: "registered safe technician",
    smar: "sheet metal assembler and riveter",
    dco: "die cast operator",
    npo: "nuclear plant operator",
    nso: [
        "nuclear station operator",
        "nuclear supervising operator"
    ],
    ro: "reactor operator",
    cwi: "certified welding inspector",
    lss: "line service supervisor",
    atcs: "air traffic control specialist",
    atc: "air traffic controller",
    eca: "emergency care attendant",
    rto: "rapid transit operator",
    oicew: "officer in charge of engineering watch",
    tst: "traffic signal technician"
}

